const en = require("./lang/eng")
const th = require("./lang/thai")

const language = {
  install(Vue) {
    Vue.mixin({
      methods: {
        $t(path: any) {
          let lang: any = localStorage.getItem('lang')
          if (!lang) {
            localStorage.setItem('lang', 'EN')
            lang = 'EN'
          }
          let current = en.eng;
          switch (lang) {
            case 'EN':
              current = en.eng
              break
            case 'TH':
              current = th.thai
              break
            case 'FALSE':
              current = false
              break
          }
          path = path.replace(/\[(\w+)\]/g, '.$1')
          path = path.replace(/^\./, '')
          var a = path.split('.')
          for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i]
            if (!current) {
              return '▒▓▒▓▒▓▒'
            } else if (k in current) {
              current = current[k];
            } else {
              return ' %_' + k + '_% '
            }
          }
          return current
        }
      }
    })
  }
}

import Vue from 'vue'
Vue.use(language)
